import { createAction } from "redux-starter-kit";
import { get } from "lodash";

import {
  FETCH_FREEZEEVENTS_FAILURE,
  FETCH_FREEZEEVENTS_REQUEST,
  FETCH_FREEZEEVENTS_SUCCESS
} from "../types";

const fetchFreezeEventsNext = factoringId => async (
  dispatch,
  getState,
  { api }
) => {
  const state = getState();
  const next = get(state, [
    "factoringClient",
    "freezeEvents",
    factoringId,
    "next"
  ]);
  if (!next) {
    return null;
  }

  try {
    dispatch(createAction(FETCH_FREEZEEVENTS_REQUEST)());
    const response = await api.factoring.getFreezeEventsByUrl(next);
    dispatch(
      createAction(FETCH_FREEZEEVENTS_SUCCESS)({
        factoringId,
        results: response.results,
        next: response.next,
        append: true
      })
    );
    return response;
  } catch (err) {
    dispatch(createAction(FETCH_FREEZEEVENTS_FAILURE)(err));
    throw err;
  }
};

export default fetchFreezeEventsNext;
